import { ComponentClass } from 'react';
export { ComponentClass };
import { OwaSuiteHeaderProps } from './components/OwaSuiteHeader';
export { OwaSuiteHeaderProps };

import { default as OwaSuiteHeader } from './components/OwaSuiteHeader';
export { OwaSuiteHeader };
export { default as launchSuiteHelpPane } from './actions/launchSuiteHelpPane';
export { default as launchGetStartedPane } from './actions/launchGetStartedPane';

import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "OwaSuiteHeader" */ './lazyIndex')
);

export let LazyLaunchGetStartedSuiteFlexPane = new LazyAction(
    lazyModule,
    m => m.launchGetStartedPane
);

import './orchestrators/attachWebPushDiscovery';
